import React from "react";
import { connect } from "react-redux";
import { Button, Label, Input, FormText, FormGroup, Row, Col } from "reactstrap";
import { Field, reduxForm, FieldArray,formValueSelector } from "redux-form";
import "react-dropdown/style.css";
import { Card, CardHeader, CardBody } from 'reactstrap';
import renderSelectField from '../../../../shared/components/form/Select';
import PropTypes from 'prop-types';
import renderCheckBoxField from '../../../../shared/components/form/CheckBox';
import { withTranslation } from 'react-i18next';
import { Checkbox, Form } from 'semantic-ui-react';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = "Please enter the Job Description name";
  }
  return errors;
};

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

const renderCheckBox = ({ input, label }) => {
  return (
    <Form.Field>
      <Checkbox
        label={label}
        checked={input.value ? true : false}
        onChange={(e, { checked }) => input.onChange(checked)}
      />
    </Form.Field>
  );
};


const renderTypeList = ({ fields, meta: { error, submitFailed } }) => (
  <div>
    <Card>
     <CardHeader >
     <Row>
      <Col  className="text-left">
        Type List
      </Col>
      <Col className="text-right">
      {submitFailed && error && <span>{error}</span>}
      </Col>
    </Row>
    </CardHeader>
    <CardBody>
    {fields.map((param, index) =>  (

      <Row key={index}>
        <Col xs="12" sm="5" className="form form--horizontal">
          <div className="form__form-group">
                <div className="form__form-group-field">
                  <Field
                    component={renderField}
                    name={`${param}.name`}
                    type="text"
                  />
                </div>
           </div>
        </Col>
        <Col xs="12" sm="5" className="form form--horizontal">
          <div className="form__form-group">
                <div className="form__form-group-field">
                  <Field name={`${param}.value`} label="Include Asset/Process Type" component={renderCheckBox} />
                </div>
           </div>
        </Col>
      </Row>
    )
    )}
    </CardBody>
   </Card>
  </div>
);

let CollectionForm = props => {
  const { handleSubmit, submitting,  initialValues,  collection_purpose, t} = props;
  const COLLECTION_TYPE = [{ value: 'SMART_FACTORY', label: 'SMART FACTORY' },
                            { value: 'IT_OPS', label: 'IT OPS' },
                            { value: 'FACILITY', label: 'FACILITY' },
                            { value: 'SMART_BUILDING', label: 'SMART BUILDING' }];

  const COLLECTION_PURPOSE = [{ value: 'ASSET_MONITORING', label: 'ASSET MONITORING' },
                            { value: 'PROCESS_MONITORING', label: 'PROCESS MONITORING' },
                            { value: 'ASSET_INSPECTION', label: 'ASSET INSPECTION' }];


  return (
    <form  onSubmit={handleSubmit}>
      <Row>
        <Col xs="12" sm="5" className="form form--horizontal" >

           <div className="form__form-group">
                <span className="form__form-group-label">{t('collection_settings.collection_form.name')}</span>
                <div className="form__form-group-field">
                  <Field
                    name="collection_name"
                    component={renderField}
                    type="text"
                    placeholder="Name"
                  />
                </div>
           </div>

            <div className="form__form-group">
                <span className="form__form-group-label">Purpose</span>
                <div className="form__form-group-field">
                 <Field
                    component={renderSelectField}
                    name="collection_purpose"
                    placeholder="Purpose"
                    type="select"
                    options={COLLECTION_PURPOSE}
                  />
                </div>
           </div>

           <div className="form__form-group">
                <span className="form__form-group-label">Industry Code</span>
                <div className="form__form-group-field">
                  <Field
                    component={renderField}
                    name="global_industry_code"
                    placeholder="Distinguishing code for industry"
                    type="text"
                  />
                </div>
           </div>

           <div className="form__form-group">
                <span className="form__form-group-label">Trend Interval</span>
                <div className="form__form-group-field">
                  <Field
                    component={renderField}
                    name="trend_interval"
                    placeholder="In seconds (for ex. 604800 for a week)"
                    type="number"
                  />
                </div>
           </div>

        </Col>
        <Col xs="12" sm="5" className="form form--horizontal">
            <div className="form__form-group">
                <span className="form__form-group-label">Type</span>
                <div className="form__form-group-field">
                 <Field
                    component={renderSelectField}
                    name="collection_type"
                    placeholder="Type"
                    type="select"
                    options={COLLECTION_TYPE}
                  />
                </div>
           </div>

            <div className="form__form-group">
                <span className="form__form-group-label">Industry</span>
                <div className="form__form-group-field">
                  <Field
                    component={renderField}
                    name="industry"
                    placeholder="Ex. Manufacturing"
                    type="text"
                  />
                </div>
           </div>

           <div className="form__form-group">
                <span className="form__form-group-label">Location</span>
                <div className="form__form-group-field">
                  <Field
                    component={renderField}
                    name="location"
                    placeholder="Country, State, City"
                    type="text"
                  />
                </div>
           </div>

        </Col>
      </Row>
      <br />
       <Row>
        <Card>
         <CardHeader >
            {t('collection_settings.collection_form.type_list_title')}
        </CardHeader>
        </Card>
      </Row>

      {collection_purpose.value=='PROCESS_MONITORING'?
        <FieldArray name="process_type_params" component={renderTypeList} />
        :<FieldArray name="asset_type_params" component={renderTypeList} />
      }
      <br />
      <Row>
        <Col xs="12" sm="5" className="text-right">
          <div >
              <Button color="primary" disabled={submitting} type="submit">
                Save
              </Button>
          </div>
        </Col>
        <Col xs="12" sm="5" className="text-left">
           <div >
              <Button color="primary" onClick={props.onCancel}>
                Cancel
              </Button>
          </div>
        </Col>
      </Row>
    </form>
  );
};

function mapStateToProps(state, ownProps, context) {
      console.log("state change for Collection Form, and state is ", state);
      let {form_data} = ownProps;
      console.log("form_data ", form_data);
      let collection_purpose = selector(state, "collection_purpose");
      console.log(collection_purpose);
      if (!collection_purpose){
            collection_purpose = { value: 'ASSET_MONITORING', label: 'ASSET MONITORING' };
      }
      if (form_data.formType == "clone") {
            delete form_data._id;
      }
      return { initialValues: form_data,  collection_purpose};
}

let CollectionData = reduxForm({
  validate: validate,
  form: "CollectionForm",
  enableReinitialize: true
})(CollectionForm);

const selector = formValueSelector('CollectionForm');

export default withTranslation('common') (connect(state => mapStateToProps,{})(CollectionData));
